import { ProtocolMetadata } from "@/types";
import { supHexToHsl } from "@/utils";

export default function useProtocolColor(singleProtocol: ProtocolMetadata | undefined, defaultColor: string = "#404040") {
  const isCustomColor = singleProtocol && singleProtocol.is_authenticated && singleProtocol.primary_color;
  const calculatedColors = supHexToHsl(isCustomColor ? `${singleProtocol.primary_color}` : defaultColor);

  return {
    isCustomColor,
    color: (isCustomColor ? singleProtocol.primary_color : defaultColor) as string,
    contrastColor: `${calculatedColors?.textColor}`,
  };
}
